import * as HttpService from "../../../../service/HttpService";


/**
 * 添加能耗分析报告
 */
export const addEnergyAnalysisReport = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/addEnergyAnalysisReport", params);
};

/**
 * 上传pdf到oss服务器
 */
export const savePDF = (params) => {
    return HttpService.postForm(HttpService.DOMAIN + "/energyAnalysisCreate/savePDF",params);
};

/**
 * 用电量统计（按用能客户）
 */
export const selCeCustByUnitId = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selCeCustByUnitId", params);
};

/**
 * 用电量统计（按用能客户）
 */
export const selTitleDetailed = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selTitleDetailed", params);
};

/**
 * 用电量统计（按用能容器）
 */
export const selCecntrByUnitId = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selCecntrByUnitId", params);
};

/**
 * 用电量统计（按用能客户建筑空间设备分类）
 */
export const selCebsdByUnitId = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selCebsdByUnitId", params);
};

/**
 * 能耗趋势
 */
export const selConsumptionTrend = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selConsumptionTrend", params);
};

/**
 * 能耗同环比分析
 */
export const selSameCycleRatio = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selSameCycleRatio", params);
};

/**
 * 管理节能收益
 */
export const selSavingIncome = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selSavingIncome", params);
};

/**
 * 管理节能收益同环比分析
 */
export const selIncomeSameCycleRatio = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selIncomeSameCycleRatio", params);
};

/**
 * 计划外事件
 */
export const selUnplannedEvents = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selUnplannedEvents", params);
};

/**
 * 计划外事件具体明细
 */
export const selUnplannedEventsDetailed = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selUnplannedEventsDetailed", params);
};

/**
 * 管理节能收益具体明细
 */
export const selSavingIncomeDetailed = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/energyAnalysisCreate/selSavingIncomeDetailed", params);
};